import React from 'react';
import { connect } from 'react-redux';
import StepNavButtons from '../Sections/StepNavButtons';
import GasContractor from '../Sections/OptionalCustomerDetails/GasContractor';
import SecondaryAccoundContact from '../Sections/OptionalCustomerDetails/SecondaryAccoundContact';
import EmergencyContact from '../Sections/OptionalCustomerDetails/EmergencyContact';
import MoreContactPerson from '../Sections/OptionalCustomerDetails/MoreContactPerson';
import { BillingAddressValidation } from '../Sections/CustomerDetails/Common/BillingAddress';
import { selectAllNewContacts } from '../../selectors/OptionalCustomerDetail';
import util from '../../lib/util';
import { nextStepClicked } from '../../actions';
class OptionalCustomerDetails extends React.Component {
    constructor() {
        super();
        this.state = { savingContacts: false };
    }
    componentWillReceiveProps(newProps) {
        if (this.state.savingContacts && newProps.allContactsSaved) {
            this.setState({ savingContacts: false });
           this.handleNextClick(newProps);
        }
    }
    onNextClick = () => {
        const p = this.props;
        let validators = BillingAddressValidation("secondAccountContactAddress", this.props.secondAccountContactAddress);
        //TODO: Add validation
        // if (p.isBusiness)
        //     validators = [...validators, MoreContactPersonValidation()];
        // else
        //     validators = [...validators, EmergencyContactValidation()];
        if (util.validate(validators, p.form, p.formError)) {
            const contacts = p.contacts;
            if (contacts.length > 0) {
                this.setState({ savingContacts: true });
                p.saveContacts(contacts);
            }
            else
               this.handleNextClick(p);
        }
    }
    handleNextClick= (p) => {
         if (!p.isLoggedIn && p.verifyAccountRetriesExceed) {
           p.onNextStepClicked(4);
         }
         else
            p.onNextClick();
    }
    render() {
        const p = this.props;
        return (
            <div>
                <GasContractor />
                { !p.isResume?
                <div>
                    <SecondaryAccoundContact name="secondAccountContact" selectedAddress={p.secondAccountContactAddress}
                        isBusiness={p.isBusiness} disabled={p.secondAccountContactSaved} />
                    {p.isBusiness ? <MoreContactPerson /> : <EmergencyContact disabled={p.emergencyContactSaved} />}
                </div>
                :
                null
                }
                <StepNavButtons text="Next step" onNextClick={this.onNextClick}
                    onBackClick={p.onBackClick} onCancelClick={p.onCancelClick} />
            </div>
        );
    }
}

OptionalCustomerDetails.propTypes = {
    id: React.PropTypes.string.isRequired,
    onNextClick: React.PropTypes.func.isRequired,
    onBackClick: React.PropTypes.func.isRequired,
    onCancelClick: React.PropTypes.func.isRequired
};
const mapStateToProps = (state) => {
    return {
        secondAccountContactAddress: state.form.secondAccountContactAddress,
        secondAccountContactSaved: state.form.secondAccountContactSaved,
        emergencyContactSaved: state.form.emergencyContactSaved,
        isBusiness: state.form.customerType != "1",
        form: state.form,
        bpNumber: state.gas.bpNumber,
        isResume : state.gas.isResume,
        allContactsSaved: state.gas.allContactsSaved,
        contacts: selectAllNewContacts(state),
         verifyAccountRetriesExceed: state.gas.verifyAccountExceed
    };
};
const mapDispatchToProps = (dispatch) => {
    return {
        formError: (name, error) => dispatch({ type: 'FORM_ERROR', name, error }),
        saveContacts:(contacts)=> dispatch({ type: "SAVE_CONTACTS", contacts }),
            onNextStepClicked: (activeIndex) => dispatch(nextStepClicked(activeIndex)),
    };
};
export default connect(mapStateToProps, mapDispatchToProps)(OptionalCustomerDetails);